import Vue from 'vue'
import Router from 'vue-router'
const both = (name) => () => import(`@/views/${name}`);
Vue.use(Router)
var routes=[
	{
		path: '/index',
		component: both("index"),
		name: '首页',
		alias:'/'
	},
	{
		path: '/bccsc',
		component: both("zhongjiaxuexiao"),
		name: '北京中加学校',
        meta:{
            animation:true,
        },
	},
	{
		path:'/zhongjiaxuexiao',
		redirect:'/bccsc'
	},
	{
		path: '/bcs',
		component: both("tongzhouhuaren"),
		name: '北京通州华仁学校',	
        meta:{
            animation:true,
        },
	},
	{
		path:'/tongzhouhuaren',
		redirect:'/bcs'
	},
	{
		path: '/elementaryschool',
		component: both("xiaoxue"),
		name: '小学',
        meta:{
            animation:true,
        },
	},
	{
		path:'/xiaoxue',
		redirect:'/elementaryschool'
	},
	{
		path: '/middleschool',
		component: both("chuzhong"),
		name: '初中',
        meta:{
            animation:true,
        },
	},
	{
		path:'/chuzhong',
		redirect:'/middleschool'
	},
	{
		path: '/highschool',
		component: both("guojigaozhong"),
		name: '国际高中',
        meta:{
            animation:true,
        },
	},
	{
		path:'/guojigaozhong',
		redirect:'/highschool'
	},
	{
		path: '/gwacademy',
		component: both("changchengshuyuan"),
		name: '长城书院',
        meta:{
            animation:true,
        },
	},
	{
		path:'/changchengshuyuan',
		redirect:'/gwacademy'
	},
	{
		path: '/studyinChina',
		component: both("laihua"),
		name: '来华',
        meta:{
            animation:true,
        },
	},
	{
		path:'/laihua',
		redirect:'/studyinChina'
	},
	{
		path: '/exploring',
		component: both("tansuo"),
		name: '探索',
        meta:{
            animation:false,
        },
	},
	{
		path:'/tansuo',
		redirect:'/exploring'
	},
	{
		path: '/news',
		component: both("news_info"),
		name: '新闻详情',
        meta:{
            animation:false,
        },
	},
	{
		path:'/news_info',
		redirect:'/news'
	},
	{
		path: '/zhaosheng',
		component: both("zhaosheng"),
		name: '招生',
        meta:{
            animation:false,
        },
	},
	{
		path: '/tuifeizhengce',
		component: both("tuifeizhengce"),
		name: '退费政策',
        meta:{
            animation:false,
        },
	},
	{
		path: '/yinsizhengce',
		component: both("yinsizhengce"),
		name: '隐私政策',
        meta:{
            animation:false,
        },
	},
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/index.js